import { Accordion, AccordionTab } from 'primereact/accordion';
import { Avatar } from 'primereact/avatar';
import { Image } from 'primereact/image';
import { Message } from 'primereact/message';
import React from "react";
import 'react-slideshow-image/dist/styles.css';
import { _endPoints } from '../Helper/links';
import logo_svg from "../public/images/logo.svg";
import imgCustomer from "../public/images/user.avif";

function CustomerShowComponet(props) {
    return (
        <div className="ibox" >
            <div class="row">
                <div class="col-md-12">
                    <div className="row font-15">
                        <div className="col-md-12 " >
                            <div className="font-bold mt-4 " ></div>
                            <div className='row'>
                                <div className='col-md-2 pt-5'>
                                    <div class="media-img">
                                        <center>
                                            <Avatar image={imgCustomer} className="flex mr-2" size="xlarge" style={{ width: "150px", height: "150px", transition: "transform 10s ease" }} shape="circle" />
                                        </center>
                                    </div>
                                </div>

                                <div className='col-md-10'>
                                    <hr></hr>
                                    <br></br>
                                    <div className='row'>
                                        <div className="col-md-4 col-12  mb-4 font-bold" >
                                            <div class="media-heading font-16" >
                                                <i class="ti-user font-26 text-muted ml-3" dir='rtl'></i>
                                                {props?.customer?.visitor_name ? <>{props?.customer?.visitor_name}</> : <>-</>}
                                            </div>
                                        </div>
                                        <div className="col-md-4 col-12  mb-4 font-bold" >
                                            <div class="media-heading font-16" >
                                                <i class="fa fa-phone font-26 text-muted ml-3 pt-1"></i>
                                                <p style={{ display: "inline" }}>  {props?.customer?.phone_number ? <>{props?.customer?.phone_number}  <small class=" text-muted" dir='ltr' > +218 </small></> : <>-</>}</p>
                                            </div>
                                        </div>
                                        <div className="col-md-4 col-12  mb-4 font-bold" >
                                            <div class="media-heading font-16" >
                                                <i class="fa fa-whatsapp font-26 text-muted ml-3 pt-1"></i>
                                                <p style={{ display: "inline" }}>
                                                    {props?.customer?.whatsapp_number && props?.customer?.whatsapp_number !== 'null' ? <>{props?.customer?.whatsapp_number} +</> : <>-</>}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <hr></hr>
                                    <br></br>
                                    <div className='row'>
                                        <div className="col-md-4 col-12  mb-4 font-bold" >
                                            <div class="media-heading font-16" >
                                                <i class="fa fa-key font-26 text-muted ml-3 pt-1"></i>
                                                <p style={{ display: "inline" }}>
                                                    {props?.customer?.national_number ? <>{props?.customer?.national_number} </> : <>-</>}
                                                </p>
                                            </div>
                                        </div>
                                        <div className="col-md-4 col-12  mb-4 font-bold" >
                                            <div class="media-heading font-16" >
                                                <i class="fa fa-map font-26 text-muted ml-3 pt-1"></i>
                                                <p style={{ display: "inline" }}>
                                                    {props?.customer?.name_city ? <>{props?.customer?.name_city}</> : <>-</>}
                                                </p>
                                            </div>
                                        </div>
                                        <div className="col-md-4 col-12  mb-4 font-bold" >
                                            <div class="media-heading font-16" >
                                                <img src={logo_svg} alt='app' width={30} height={30} class="font-26 text-muted ml-3"></img>
                                                <p style={{ display: "inline" }}>  {props?.customer?.ID_customer ? props?.customer?.id_user ? <>مشتــرك</> : <>غيــر مشتــرك</> : <>-</>}</p>
                                            </div>
                                        </div>
                                    </div>

                                    <hr></hr>
                                    <br></br>

                                    <div className='row'>
                                        <div className="col-md-6 col-6  mb-4 font-bold" >
                                            <i class="pi pi-file font-26 text-muted ml-3 pt-1"></i>
                                            <p style={{ display: "inline" }} class="font-13 ">
                                                {props?.customer?.ID_customer ? props?.customer?.dentity_document?.length > 0 ?
                                                    <>
                                                        {props?.customer?.dentity_document.map(index => {
                                                            return <>{index?.name_identity} , </>
                                                        })}
                                                        <br></br>
                                                        {props?.customer?.verification ? <Message severity="success" icon="pi pi-check ml-2" text="تم التحـــقق" className='mr-5' /> : <Message severity="error" icon="pi pi-times ml-2" text="لم يتم التحــقق" className='mr-5' />}

                                                    </> : <> لا يــوجد إتبــات هويــة</> : <>-</>}
                                            </p>
                                        </div>
                                        <div className="col-md-6 col-6  mb-4 font-bold" >
                                            <i class="fa fa-warning font-26 text-muted ml-3 pt-1"></i>
                                            <p style={{ display: "inline" }} class="font-13 ">{props?.customer?.note ? <>{props?.customer?.note} </> : <>-</>}</p>
                                        </div>
                                    </div>
                                </div>

                                <div className='col-md-12 col-12'>
                                    <Accordion >
                                        {props?.customer?.dentity_document?.map(index => {
                                            return (
                                                <AccordionTab header={`${index.name_identity}`} >
                                                    <center>
                                                        <table className="table table-bordered m-0 p-0">
                                                            <tr >
                                                                <th style={{ textAlign: "center", width: "30%" }}>
                                                                    <h6 >  رقم {index.name_identity} </h6>
                                                                </th>
                                                                <th style={{ textAlign: "right" }}>
                                                                    <h6 > {index.value_key} </h6>
                                                                </th>
                                                            </tr>
                                                            <tr >
                                                                <th style={{ textAlign: "center" }} colSpan={2}>
                                                                    <Image src={_endPoints.customers.files + index.path_document} alt="Image" width="100%" preview
                                                                        onError={(e) => {
                                                                            e.target.src = imgCustomer;
                                                                        }}
                                                                    />
                                                                </th>
                                                            </tr>
                                                        </table>
                                                    </center>
                                                </AccordionTab>
                                            )
                                        })}
                                    </Accordion>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default CustomerShowComponet